import type { IconProps } from '../types/IconProps.ts';
export const MessageSquareText: IconProps = {
    name: 'MessageSquareText',
    children: [
        `<path d="M2 5c0-1.1.9-2 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H7a3 3 0 0 0-1.8.6l-2.88 2.16A.2.2 0 0 1 2 21.6zM7 7h8M7 15h6M7 11h10" />`,
    ]
};